<template>
    <div class="page">
        <div class="content"  :style="{backgroundImage: `url(${bgUrl})`}">
            <div class="topHead">
                <topComponent title="合作用人单位数据"></topComponent>
            </div>
            <div  class="date-picker flex_r">
                <el-date-picker
                        class="date-picker-item"
                        @change="datePackerChange"
                        v-model="startData"
                        type="date"
                        placeholder="开始日期"
                        value-format="yyyy-MM-dd"
                >
                </el-date-picker>
                <span class="date-picker-space"> 至 </span>
                <el-date-picker
                        class="date-picker-item"
                        @change="datePackerChange"
                        v-model="endData"
                        placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </div>


            <div class="top-row">
                <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
                        <div class="top-item boxbgimage flex_l">
                            <div class="breathebg"></div>
                            <span class="numberTitle">合作企业数量:</span>
                            <span class="number">{{state.deparmtent_count}}</span>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                        <div class="top-item boxbgimage flex_c" >
                            <!--<div class="breathebg"></div>-->
                            <span class="numberTitle">累计提供职位数量:</span>
                            <span class="number">{{state.position_count}}</span>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7" style="overflow: hidden">
                        <div class="top-item boxbgimage flex_l" >
                            <img  src="../assets/image/line_ex.png" class="line_animation" style="height: 20px;top: -10px;opacity: 0.7"/>
                            <div class="breathebg"></div>
                            <span class="numberTitle">累计提供岗位数量:</span>
                            <span class="number">{{state.intent_count}}</span>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="bottom-row">
                <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
                        <div class="bottom-col" style="overflow: hidden">
                            <div style="width: 100%;height: 282px" class="boxbgimage" >
                                <div class="itemTitleView">行业分布</div>
                                <div class="hangye" ref="industryDistributionView"></div>
                            </div>
                            <div style="width: 100%;;margin-top: 26px;position: relative" class="boxbgimage col-3-box-h boxbgimage_l">
                                <img  src="../assets/image/line.png" class="line_animation"/>
                                <el-row :gutter="0" class="col-3-box-h">
                                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                        <div>
                                            <div class="itemTitleView">规模分布</div>
                                            <div ref="scaleDistributionView" class="col-3-item"></div>
                                        </div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                        <div>
                                            <div class="itemTitleView">单位性质</div>
                                            <div ref="danweixingzhiView" class="col-3-item"></div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10" style="position: relative" class="mapMobileHeight">
                        <div class="bottom-col" ref="chinaMapView" ></div>
                        <!--<div class="bottom-col" ref="henanMapView"  v-show="mapType=='henan'"></div>-->
                        <div class="maplegendBox">
                            <div class="itemTitleView">企业地域分布 （{{mapType=='china'?'全国':'河南'}}）</div>
                            <ul v-if="mapType=='china'">
                                <li class="flex_l" v-for="(province,index) of state.proviceLevelList">
                                    <div :class="{'maplegendNumber':index<=2,'maplegendNumberDown':index>2}">{{index+1}}</div>
                                    <div class="maplegendTitle">{{province.text}}</div>
                                    <div class="maplegendBarhover" :class="{'maplegendBar':index<=2,'maplegendBarDown':index>2}" :style="{width: province.value+20+'px'}">
                                        <span>{{province.count}}</span>
                                    </div>
                                </li>
                            </ul>
                            <ul v-if="mapType=='henan'">
                                <li class="flex_l" v-for="(province,index) of state.cityLevelList">
                                    <div :class="{'maplegendNumber':index<=2,'maplegendNumberDown':index>2}">{{index+1}}</div>
                                    <div class="maplegendTitle">{{province.text}}</div>
                                    <div class="maplegendBarhover" :class="{'maplegendBar':index<=2,'maplegendBarDown':index>2}" :style="{width: province.value+40+'px'}">
                                        <span>{{province.count}}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div v-if="mapType=='henan' && isShowCustomScal" class="scalMapBox">
                            <div style="font-size: 14px;margin-top: 10px;position: relative">自定义缩放   <span @click="CustomScalChange" class="scalMapClose">x</span></div>
                            <el-slider v-model="value2" label="比例" @change="sliderChange"></el-slider>
                        </div>
                        <!--<el-radio-group v-model="mapType" size="mini" @change="mapTypeChange" class="mapTypeChange">-->
                            <!--<el-radio-button label="china"></el-radio-button>-->
                            <!--<el-radio-button label="henan"></el-radio-button>-->
                        <!--</el-radio-group>-->
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
                        <div class="bottom-col">
                            <div style="width: 100%;height: 424px" class="boxbgimage">
                                <div class="col-3-row-1-box">
                                    <div class="itemTitleView">职位类别</div>
                                    <div class="col-3-row-1-box-chart" ref="zhiweileibieView"></div>
                                </div>
                                <div class="col-3-row-1-box">
                                    <div class="itemTitleView">专业技能要求TOP 10</div>
                                    <div class="col-3-row-1-box-chart" ref="zhuanyejinengView"></div>
                                </div>
                            </div>
                            <div class="boxbgimage col-3-row-2" style="overflow: unset">
                                <div class="col-3-row-2-box">
                                    <div class="itemTitleView">月薪范围</div>
                                    <div class="col-3-row-2-box-item" ref="yuexinView"></div>
                                </div>
                                <div class="col-3-row-2-box">
                                    <div class="itemTitleView">学历范围</div>
                                    <div class="col-3-row-2-box-item" ref="xueliView"></div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>
<script>
    import {ref,getCurrentInstance,onMounted,reactive,onBeforeUnmount,onUnmounted} from 'vue'
    import basicApi from '../public/http/index';
    import {ElDatePicker} from 'element-plus'

    import {initEchart,
        initguiMoFenBu,
        initdanweixingzhi,
        initZhiweileibie,
        initZhuanyejinengChart,
        inityuexinChart,
        initxueliChart,
        initMap,
        initHenanMap
    } from '../public/companyChart'

    export default {
        setup() {
            // const bgUrl = "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fattachments.gfan.com%2Fforum%2F201606%2F21%2F232223fthl5rrbtrz81htt.jpg&refer=http%3A%2F%2Fattachments.gfan.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1614320261&t=721cc876e8fab6e67bb56ac4e7841171";
            // 系统默认图片
            // 行业分布
            const industryDistributionView=ref('industryDistributionView');
            // 规模分布
            const scaleDistributionView = ref('scaleDistributionView');
            // 单位性质
            const danweixingzhiView=ref('danweixingzhiView');
            // 职位类别
            const zhiweileibieView=ref('zhiweileibieView');
            // 专业技能
            const zhuanyejinengView=ref('zhuanyejinengView');
            // 月薪范围
            const yuexinView=ref('yuexinView');
            // 学历
            const xueliView=ref('xueliView');
            // 地图
            const chinaMapView = ref('chinaMapView');

            const henanMapView = ref('henanMapView');

            const isShowCustomScal = ref(false);

            let timerMap = ref(false) //定时器
            // 测试提交

            let startData = ref('');
            let endData = ref('');

            var bgUrl = "url(\"../assets/image/border_default_bg_l.png\")";
            let backgroundJson =   localStorage.getItem('background');
            if(backgroundJson){
                let background = JSON.parse(backgroundJson)
                if(background.cooperation){
                    bgUrl = background.cooperation;
                }
            }
            const state = reactive({
                count: 0,
                title: '合作用人单位数据',
                proviceLevelList:[], // 地图城市排行榜
                cityLevelList:[], // 地图城市排行榜
                deparmtent_count:0,//合作企业数量
                position_count:0, //职位数量
                intent_count:0 //岗位数量
            })
            state.title = "合作用人单位数据"
            const mapType = ref("china");
            state.proviceLevelList = [];
            state.cityLevelList = []
            const value2 = ref(50)
            const henanLeftSpace = ref(50);
            const henanTopSpace = ref(50);
            var chinaMap = '';
            var hennanMap = '';
            var province_list = [];
            var city_list = [];

            onMounted(() => {
                getData()


            });
            onBeforeUnmount(()=>{
                console.log('onBeforeUnmount页面销毁')
            })

            onUnmounted(()=>{
                console.log('onUnmounted页面销毁')
            });
            const sliderChange=(e)=>{
                hennanMap = initHenanMap(henanMapView.value,[],{zoom:e});
            }
            const getData =(e)=>{
                var hangye = null;
                var guimofenbu = null;
                var danweixingzhi = null;
                var zhiweileibie = null;
                var zhuanyejineng = null;
                var yuexinfanwei = null;
                var xueliyaoqiu = null;
                var salary_list = [];
                let data = {
                }

                if(startData.value && endData.value ) {
                    let startyear =  startData.value.getFullYear();  // 获取完整的年份(4位,1970)
                    let startMonth = startData.value.getMonth()+1;  // 获取月份(0-11,0代表1月,用的时候记得加上1)
                    let startDay = startData.value.getDate();  // 获取日(1-31)

                    let endyear =  endData.value.getFullYear();  // 获取完整的年份(4位,1970)
                    let endMonth = endData.value.getMonth()+1;  // 获取月份(0-11,0代表1月,用的时候记得加上1)
                    let endDay = endData.value.getDate();  // 获取日(1-31)

                    data = {
                        start_time:startyear+'-'+ startMonth+'-' +startDay,
                        end_time:endyear+'-'+endMonth+'-'+ endDay
                    }
                }
                basicApi.getCooperation(data).then((res) => {
                    console.log('getCooperation',res.data,data)
                    if(res.status){
                        let data = res.data
                        state.deparmtent_count = data.deparmtent_count
                        state.position_count = data.position_count
                        state.intent_count = data.intent_count
                        //industry_list
                        hangye = initEchart(industryDistributionView.value, (data.industry_list || []).sort((a, b) => b.count - a.count));
                        guimofenbu = initguiMoFenBu(scaleDistributionView.value, (data.scale_list || []).sort((a, b) => b.count - a.count));
                        danweixingzhi = initdanweixingzhi(danweixingzhiView.value, (data.employer_type_list || []).sort((a, b) => b.count - a.count));
                        zhiweileibie = initZhiweileibie(zhiweileibieView.value,data.post_type_list);
                        zhuanyejineng = initZhuanyejinengChart(zhuanyejinengView.value,data.major_list);
                        yuexinfanwei = inityuexinChart(yuexinView.value, (data.salary_list || []).sort((a, b) => b.count - a.count));
                        salary_list = data.salary_list
                        xueliyaoqiu = initxueliChart(xueliView.value, (data.education_list || []).sort((a, b) => b.count - a.count));
                        province_list = data.province_list;
                        city_list = data.city_list==null?[]:data.city_list;
                        // if(mapType.value=='china') {
                        //     chinaMap = initMap(chinaMapView.value,data.province_list,mapType);
                        // } else {
                        //     hennanMap = initHenanMap(henanMapView.value,city_list,mapType);
                        // }
                        chinaMap = initMap(chinaMapView.value,data.province_list,mapType,city_list);
                        // hennanMap = initHenanMap(henanMapView.value,city_list,mapType);

                        setInterval(()=>{
                            if( mapType.value=='china'){
                                mapType.value = "henan"
                                // mapTypeChange('henan')
                            }else{
                                mapType.value='china'
                                // mapTypeChange('china')
                            }
                        },8000)
                        let ChinaMaxCount = 0;
                        province_list.map((item,index)=>{
                            if(index<=9){
                                ChinaMaxCount+=item.count
                            }
                        })
                        let proviceLevelList = []
                        province_list.map((item,index)=>{
                            if(index<=9){
                                proviceLevelList.push({
                                    code: item.code, count: item.count, text: item.name, value:(item.count/ChinaMaxCount)*100
                                })
                            }
                        })

                        let henanMaxCount = 0;
                        city_list.map((item,index)=>{
                            if(index<=9){
                                henanMaxCount+=item.count
                            }
                        })
                        let cityLevelList = []
                        city_list.map((item,index)=>{
                            if(index<=9){
                                cityLevelList.push({
                                    code: item.code, count: item.count, text: item.name, value:(item.count/henanMaxCount)*100
                                })
                            }
                        })


                        state.proviceLevelList = proviceLevelList
                        state.cityLevelList = cityLevelList

                    }
                }).catch((err) => {
                    console.log('getData', err)
                });


                window.onresize = function () {
                    if(hangye){hangye.resize();}
                    if(guimofenbu){guimofenbu.resize();}
                    if(danweixingzhi){danweixingzhi.resize();}
                    if(zhiweileibie){zhiweileibie.resize();}
                    if(zhuanyejineng){zhuanyejineng.resize();}
                    if(xueliyaoqiu){xueliyaoqiu.resize();}
                    if(chinaMap){chinaMap.resize();}
                    if(hennanMap){hennanMap.resize();}
                    if(yuexinfanwei){yuexinfanwei.resize();}
                    if(document.body.offsetWidth>=1000 && document.body.offsetWidth<1700){
                        xueliyaoqiu = initxueliChart(xueliView.value,salary_list);
                    }
                    if(chinaMap){
                        chinaMap.resize();
                    }
                }
            }
            const sliderLeftChange=(e)=>{
                // hennanMap = initHenanMap(henanMapView.value,[],{left:e});
            }
            const datePackerChange = (e) => {
                if(startData&&endData){
                    if(startData.value && endData.value){
                        console.log('datePackerChange',startData.value,endData.value)
                        getData()
                    }
                }
            }
            const mapTypeChange = (e)=>{
                 console.log('mapTypeChange',e,mapType,province_list,city_list);
                // chinaMap = initMap(chinaMapView.value,[],mapType.value);
                // chinaMap.resize()
                // if(e=='china'){
                //     // chinaMap.dispose()
                //     chinaMap = initMap(chinaMapView.value,province_list,e);
                // }else {
                //     // hennanMap.dispose()
                //     hennanMap = initHenanMap(henanMapView.value,city_list,);
                // }
            }
            const CustomScalChange = () =>{
                console.log('isShowCustomScal',isShowCustomScal)
                isShowCustomScal.value = !isShowCustomScal.value
            }
            const  par = (params)=>{
                var paramsArray = []
                Object.keys(params).forEach((key) => {
                    ////console.log(params[key] instanceof Array);
                    if(params[key] instanceof Array){
                        params[key].forEach((val)=>{
                            if(val instanceof Array){

                            }else if(val instanceof Object){

                                Object.keys(val).forEach((keys) => {
                                    paramsArray.push(key+'['+params[key].indexOf(val)+']'+'['+keys+']'+'=' + encodeURIComponent(val[keys]));
                                });

                            }else{
                                paramsArray.push(key+'['+params[key].indexOf(val)+']'+'=' + encodeURIComponent(val));
                            }

                        });
                    }else if(params[key] instanceof Object){
                        Object.keys(params[key]).forEach((keys) => {
                            if(params[key][keys] instanceof Array){//判断对象中又包含子数组的情况
                                params[key][keys].forEach((keys1) => {
                                    paramsArray.push(key+'['+keys+']'+'['+params[key][keys].indexOf(keys1)+']'+'=' + encodeURIComponent(keys1));
                                })
                            }else{
                                paramsArray.push(key+'['+keys+']'+'=' + encodeURIComponent(params[key][keys]));
                            }

                        })
                    }else{
                        paramsArray.push(key + '=' + encodeURIComponent(params[key]));
                    }

                })
                params = paramsArray.join("&");
                return params
            }
            return{
                industryDistributionView,
                scaleDistributionView,
                danweixingzhiView,
                zhiweileibieView,
                zhuanyejinengView,
                yuexinView,
                xueliView,
                chinaMapView,
                henanMapView,
                bgUrl,
                value2,
                sliderChange,
                mapType,
                mapTypeChange,
                henanLeftSpace,
                henanTopSpace,
                sliderLeftChange,
                isShowCustomScal,
                CustomScalChange,
                state,
                startData,
                endData,
                datePackerChange
            }
        }
    }
</script>

<style scoped>
    .flex_c{display: flex;flex-direction: row;align-items: center;flex-wrap: wrap;justify-content:center;}
    .flex_l{display: flex;flex-direction: row;align-items: center;flex-wrap: wrap;justify-content:flex-start;}
    .flex_r{display: flex;flex-direction: row;align-items: center;flex-wrap: wrap;justify-content:flex-end;}
    .flex_s{display: flex;flex-direction: row;align-items: center;flex-wrap: wrap;justify-content:space-between;}
    .flex_t{display: flex;flex-direction: row;flex-wrap: wrap;justify-content:center;}
    .page {
        width: 100%;height: 100vh;
        overflow: hidden;
        box-sizing: border-box;
    }
    .content {
        height: 100%;
        background: url("../assets/image/page_default_bg.png") no-repeat;
        background-size: cover;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        padding:0 20px;
        box-sizing: content-box;
        overflow-y:auto;
    }
    .top-row {
        width: 100%;
    }
    .bottom-row {
        width: 100%;
        /*margin-top: 25px;*/
        margin-bottom: 25px;
    }
    .top-item {
        height: 200px;
        margin-bottom:25px;
    }

    .bottom-col {
        min-height: 700px;
    }
    .topHead {
        width: 100%;
        height: 100px;
        margin-bottom: 15px;
    }
    .boxbgimage {
        background: url("../assets/image/border_default_bg.png") no-repeat;
        background-size: 100% 100%;
        padding: 0 16px;
        box-sizing: border-box;
        overflow: hidden
    }
    .boxbgimage_l {
        background: url("../assets/image/border_default_bg_l.png") no-repeat;
        background-size: 100% 100%;
        padding: 0 16px;
        box-sizing: border-box;
        overflow: hidden
    }
    .numberTitle {
        font-size: 28px;
        color: rgba(1, 238, 222, 1);
        margin-left: 31px;
        font-weight: bold;
        margin-right: 10px;
    }
    .number{
        font-size: 46px;
        color: rgba(242, 197, 103, 1);
        font-weight: bold;
        z-index: 2;
    }
    @media screen and (max-width: 1440px) {
        .number{
            font-size: 40px;
            color: rgba(242, 197, 103, 1);
            font-weight: bold;
        }
        .numberTitle {
            font-size: 22px;
            color: rgba(1, 238, 222, 1);
            margin-left: 15px;
            font-weight: bold;
            margin-right: 10px;
        }
    }
        /* title 44px */
    .itemTitleView{
        height: 24px;
        line-height: 24px;
        font-size: 20px;
        color: rgba(1, 238, 222, 1);
        border-left: 3px rgba(1, 238, 222, 1) solid;
        font-weight: bold;
        margin-top: 20px;
        text-align: left;
        padding-left: 5px;
    }
    .hangye {
        width: 100%;
        height: calc(100% - 44px - 25px - 15px);
        margin-top: 25px;
    }
    .col-3-box-h {
        height: 385px;
        overflow: hidden;
    }
    .col-3-item{
        width: 100%;
        height: calc(385px - 44px);
        /*overflow: hidden;*/
        box-sizing: content-box;
    }
    .col-3-row-1-box {
        width: 100%;
        height: 50%;
        box-sizing: border-box;
        overflow: hidden
    }
    .col-3-row-1-box-chart {
        width: 100%;
        height: calc(100% - 44px - 15px);
        margin-top: 15px;
    }
    .col-3-row-2{
        width: 100%;height: 246px;margin-top: 26px;
    }
    .col-3-row-2-box {
        width: 50%;
        height: 100%;
        display: inline-block
    }
    .col-3-row-2-box-item{
        width: 100%;
        height: calc(100% - 44px);
    }
    .maplegendBox{
        width: 260px;height: 260px;position: absolute;bottom: 0;
    }
    .maplegendBox ul{
        list-style: none;
        padding-left: 0;
        margin-left: 0;
    }
    .maplegendBox ul li{
        /*height: 15px;*/
        margin: 5px;
    }
    .maplegendNumber {
        width: 14px;
        height: 14px;
        font-size: 10px;
        background-color: #02D1FB;
        text-align: center;
        margin-right: 3px;
        border-radius: 3px;
        color: white;
        line-height: 14px;
    }
    .maplegendNumberDown {
        width: 14px;
        height: 14px;
        font-size: 10px;
        background-color: #3653DE;
        text-align: center;
        margin-right: 3px;
        border-radius: 3px;
        color: white;
        line-height: 14px;
    }
    .maplegendTitle {
        color: #84C7F7;
        font-size: 12px;
        width: 40px;
        text-align: left;
        line-height: 14px;
    }
    .maplegendBar{
        width: 100px;
        height: 15px;
        margin-left: 7px;
        border-bottom-right-radius: 7px;
        border-top-right-radius: 7px;
        background: -webkit-linear-gradient(right, #00CCFF 0%,#A6EDFF 100%);
        background: -o-linear-gradient(right, #00CCFF 0%,#A6EDFF 100%);
        background: -ms-linear-gradient(right, #00CCFF 0%,#A6EDFF 100%);
        background: linear-gradient(to right, #00CCFF 0%,#A6EDFF 100%);
        cursor: pointer;
    }
    .maplegendBarDown{
        width: 100px;
        height: 15px;
        margin-left: 7px;
        border-bottom-right-radius: 7px;
        border-top-right-radius: 7px;
        background: -webkit-linear-gradient(right, #3B3BE3 0%,#24A0CD 100%);
        background: -o-linear-gradient(right, #3B3BE3 0%,#24A0CD 100%);
        background: -ms-linear-gradient(right, #3B3BE3 0%,#24A0CD 100%);
        background: linear-gradient(to right, #3B3BE3 0%,#24A0CD 100%);
    }
    .maplegendBarhover {
        line-height: 15px;
        color: white;
        text-align: left;
    }
    .maplegendBarhover span{
        opacity: 0;
        margin-left: 5px;
        font-size: 12px;
    }
    .maplegendBarhover:hover{
        border: 1px white solid;
        cursor: pointer;
    }
    .maplegendBarhover:hover span{
        opacity: 1;
    }
    @media screen and (max-width: 600px) {
        /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
        .content {
            padding: 5px;
        }
        .top-item {
            margin-bottom:5px;
        }
        .bottom-col {
            margin-bottom: 5px;
        }
        .bottom-row{
            margin-top: 0;
        }
        .content {
            height: 100%;
            background: url("../assets/image/page_mobile_default_bg.png") no-repeat;
            background-size: 100% 100%;
        }
        .numberTitle {
            font-size: 20px;
            margin-left: 15px;
        }
        .number{
            font-size: 36px;
        }
        .top-item {
            height: 100px;
            margin-bottom:15px;
        }
        .col-3-box-h{
            height: 760px
        }
        .col-3-item{
            width: 100%;height: calc(385px - 44px)
        }
        .col-3-row-2-box{
            width: 100%;
            height: 246px;
        }
        .col-3-row-2{
            width: 100%;height: 490px;
        }
        .mapMobileHeight{
            height: 600px;
        }
        @-webkit-keyframes gogogo {
            0%{
                left: 0;
                opacity:0;
                filter:alpha(opacity=00); /* 针对 IE8 以及更早的版本 */
            }
            25%{
                left: 125px;
                opacity:0.7;
                filter:alpha(opacity=50); /* 针对 IE8 以及更早的版本 */
            }
            50%{
                left: 230px;
                opacity:1;
                filter:alpha(opacity=50); /* 针对 IE8 以及更早的版本 */
            }
            100%{
                left: calc(300px - 100px);
                opacity:0;
                filter:alpha(opacity=00); /* 针对 IE8 以及更早的版本 */
                overflow: hidden;
            }
        }
    }
    ::-webkit-scrollbar{width:0px}
    .breathebg{
        width: 254px;
        height: 141px;
        background: url("../assets/image/breathebg.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        right: 10px;
        top: 0;
        -webkit-animation:alpha_ 3s infinite linear ;
    }
    @-webkit-keyframes alpha_ {
        0%{
            opacity:0.2;
            filter:alpha(opacity=00); /* 针对 IE8 以及更早的版本 */
        }
        50%{
            opacity:0.8;
            filter:alpha(opacity=50); /* 针对 IE8 以及更早的版本 */
        }
        100%{
            opacity:0.2;
            filter:alpha(opacity=00); /* 针对 IE8 以及更早的版本 */
        }
    }
    @-webkit-keyframes gogogo {
        0%{
            left: 0;
            opacity:0;
            filter:alpha(opacity=00); /* 针对 IE8 以及更早的版本 */
        }
        25%{
            left: 125px;
            opacity:0.7;
            filter:alpha(opacity=50); /* 针对 IE8 以及更早的版本 */
        }
        50%{
            left: 230px;
            opacity:1;
            filter:alpha(opacity=50); /* 针对 IE8 以及更早的版本 */
        }
        100%{
            left: calc(500px - 100px);
            opacity:0;
            filter:alpha(opacity=00); /* 针对 IE8 以及更早的版本 */
            overflow: hidden;
        }
    }
    .line_animation{
        -webkit-animation:gogogo 5s infinite linear ;
        background-size:100px 3px;
        width: 100px;
        position: absolute;
        height: 3px;
        top: 0;
    }
    .question{
        position: fixed;
        right: 15px;
        top: 15px;
        z-index: 3;
    }
    .mapTypeChange {
        position: absolute;
        right: 15px;
        top: 15px;
    }
    .scalMap{
        width: 60px;height: 30px;position: absolute;bottom: 0;right: 0;font-size: 13px;
        color: #3B3BE3;
    }
    .scalMapBox{
        position: absolute;right: 0;bottom: 0;width: 200px;height: 80px;background-color: white;padding: 0 15px
    }
    .scalMapClose{
        position: absolute;left: 0px;top: 0px;
        cursor: pointer;
    }



</style>
